module.exports = __webpack_public_path__ + "img/4.f40bb44c.png";